import ImportContainer from './ImportContainer'

function ImportScreen(): JSX.Element {
    return <ImportContainer />
}

export default ImportScreen
